'use strict';

const dateHelpers = require('../helpers/dateHelpers');

const cache = {
    $body: $('body'),
    $form: $('#home-extended-search-form'),
    $inputDeparture: $('input.search-field.departure'),
    $inputDestination: $('input.search-field.destination')
}

function updateDateRange() {
    const target = $(this);
    const isFromMainForm = target.closest("#home-extended-search-form").length > 0;
    const isFromModal = target.closest(".modal-search-field").length > 0;

    let startDate, endDate;

    if (isFromMainForm) {
        startDate = target.closest("#home-extended-search-form").find('.js-datepicker-start-date').val();
        endDate = target.closest("#home-extended-search-form").find('.js-datepicker-end-date').val();

        $('.modal-search-field[id^="modal-extended-date-"] .js-datepicker-start-date').val(startDate);
        $('.modal-search-field[id^="modal-extended-date-"] .js-datepicker-end-date').val(endDate);
    } else if (isFromModal) {
        startDate = target.closest('.modal-search-field').find('.js-datepicker-start-date').val();
        endDate = target.closest('.modal-search-field').find('.js-datepicker-end-date').val();

        $('#home-extended-search-form .js-datepicker-start-date').val(startDate);
        $('#home-extended-search-form .js-datepicker-end-date').val(endDate);
    }

    window.easepick.forEach(function(picker) {
        picker.setStartDate(parseInt(startDate));
        picker.setEndDate(parseInt(endDate));

        if ((startDate === 'null' || startDate === '')
            && (endDate === 'null' || endDate === '')) {
            picker.clear();
        }
    });

    const startFormatted = startDate ? dateHelpers.formatDate(startDate) : '';
    const endFormatted = endDate ? dateHelpers.formatDate(endDate) : '';

    const summaryText = startFormatted && endFormatted ? `Dal ${startFormatted} al ${endFormatted}` : '';
    $('#home-extended-search-form input[id^="extended-date-"]').val(summaryText);
}

cache.$body.on('change', '#home-extended-search-form .js-datepicker-start-date, ' +
    '#home-extended-search-form .js-datepicker-end-date, ' +
    '.modal-search-field input[id^="modal-extended-date-"].js-datepicker-start-date, ' +
    '.modal-search-field input[id^="modal-extended-date-"].js-datepicker-end-date', updateDateRange);

function applyExtendedSuggestion($clickedItem, $searchField) {
    if (!$searchField.length) {
        return;
    }

    const nameValue = $clickedItem.find('.name').text().trim();
    const geocode = $clickedItem.find('.item-link').data('geocode');
    const isProduct = $clickedItem.find('[id^="product-"]').length > 0;
    const $categoryElement = $clickedItem.find('[id^="category-"]');
    const categoryType = $categoryElement.length ? $categoryElement.data('type') : null;

    function fill($field) {
        if (!$field.length) {
            return;
        }
        $field.val(nameValue);
        if (geocode) {
            $field.attr('data-geocode', geocode);
            $field.removeClass('is-invalid');
        }
        if (isProduct) {
            $field.removeAttr('data-type').attr('data-type', 'tour');
        } else if (categoryType) {
            $field.removeAttr('data-type').attr('data-type', categoryType);
        }
    }

    fill($searchField);

    const searchFieldId = $searchField.attr('id');
    if (searchFieldId) {
        fill($(`#modal-${searchFieldId}`).find('input.search-field'));
    }
}

cache.$body.on('mousedown', '#home-extended-search-form .item.suggestion-result', (e) => {
    e.preventDefault();

    const $clickedItem = $(e.currentTarget);
    const $searchField = $clickedItem.closest('.field-container').find('input.search-field');

    $searchField.focus();
    applyExtendedSuggestion($clickedItem, $searchField);
    $searchField.blur();
});

$(document).on('keydown', '#home-extended-search-form input.search-field:not(.datepicker)', function (e) {
    if (e.which !== 13) {
        return;
    }

    const $selected = $(this)
        .closest('.field-container')
        .find('.suggestions .item.suggestion-result.selected')
        .first();

    if (!$selected.length) {
        return;
    }

    e.preventDefault();
    applyExtendedSuggestion($selected, $(this));
    this.blur();
});

cache.$body.on('mousedown', '#home-extended-search-form .datepicker-container', (e) => {
    e.preventDefault();

    const $clickedItem = $(e.currentTarget);
    const $searchField = $clickedItem.closest('.field-container').find('input.search-field');

    $searchField.focus();
});

cache.$body.on('click', '#home-extended-search-form .js-datepicker-apply', (e) => {
    const $fieldContainer = $(e.currentTarget).closest('.field-container');
    suppressDatepickerOpen = true;
    closeHomeDatepicker($fieldContainer);
    $fieldContainer.find('input.search-field.datepicker').focus();
    setTimeout(function () { suppressDatepickerOpen = false; }, 0);
});

$(document).on('input', 'input.search-field.departure', function () {
    cache.$inputDeparture.removeAttr('data-geocode');
});

$(document).on('input', 'input.search-field.destination', function () {
    cache.$inputDestination.removeAttr('data-type');
});

function commitTypedDate($field) {
    const raw = $field.val();
    const $startField = $field.siblings('.js-datepicker-start-date');
    const $endField = $field.siblings('.js-datepicker-end-date');

    if (!raw || !raw.trim()) {
        $field.removeClass('is-invalid');
        $field.siblings('.invalid-feedback').text('');
        $startField.val('');
        $endField.val('');
        updateDateRange.call($startField[0]);
        return;
    }

    const range = dateHelpers.parseDateRange(raw);

    if (!range) {
        $field.addClass('is-invalid');
        $field.siblings('.invalid-feedback').text($field.data('pattern-mismatch'));
        return;
    }

    $field.removeClass('is-invalid');
    $field.siblings('.invalid-feedback').text('');
    $startField.val(range.start);
    $endField.val(range.end);
    updateDateRange.call($startField[0]);
}

$(document).on('change', 'input[id^="extended-date-"]', function () {
    commitTypedDate($(this));
});

function findPickerForElement(easepickEl) {
    var pickers = window.easepick || [];
    for (var i = pickers.length - 1; i >= 0; i--) {
        if (pickers[i] && pickers[i].options && pickers[i].options.element === easepickEl) {
            return pickers[i];
        }
    }
    return null;
}

var suppressDatepickerOpen = false;

function openHomeDatepicker($fieldContainer) {
    if (suppressDatepickerOpen || $fieldContainer.hasClass('js-datepicker-open')) {
        return;
    }
    $fieldContainer.addClass('js-datepicker-open')
        .find('input.search-field.datepicker')
        .attr('aria-expanded', 'true');
}

function closeHomeDatepicker($fieldContainer) {
    if (!$fieldContainer.hasClass('js-datepicker-open')) {
        return;
    }
    $fieldContainer.removeClass('js-datepicker-open')
        .find('input.search-field.datepicker')
        .attr('aria-expanded', 'false');
}

// Open when the date field gains focus (mouse click or Tab-in).
$(document).on('focusin', '#home-extended-search-form input.search-field.datepicker', function () {
    openHomeDatepicker($(this).closest('.field-container'));
});

$(document).on('focusout', '#home-extended-search-form .field-container', function (e) {
    if (!$(this).hasClass('js-datepicker-open')) {
        return;
    }
    var next = e.relatedTarget || (e.originalEvent && e.originalEvent.relatedTarget);
    if (next && !this.contains(next)) {
        closeHomeDatepicker($(this));
    }
});

$(document).on('mousedown', function (e) {
    $('#home-extended-search-form .field-container.js-datepicker-open').each(function () {
        if (!this.contains(e.target)) {
            closeHomeDatepicker($(this));
        }
    });
});

$(document).on('keydown', '#home-extended-search-form .field-container', function (e) {
    if (e.key !== 'Escape') {
        return;
    }
    var $fieldContainer = $(this);
    if (!$fieldContainer.hasClass('js-datepicker-open')) {
        return;
    }
    e.preventDefault();
    e.stopPropagation();
    suppressDatepickerOpen = true;
    closeHomeDatepicker($fieldContainer);
    $fieldContainer.find('input.search-field.datepicker').focus();
    setTimeout(function () { suppressDatepickerOpen = false; }, 0);
});

$(document).on('keydown', 'input[id^="extended-date-"]', function (e) {
    var $fieldContainer = $(this).closest('.field-container');

    if (e.key === 'Enter') {
        e.preventDefault();
        $(this).trigger('change');
    } else if (e.key === 'ArrowDown') {
        openHomeDatepicker($fieldContainer);
        var easepickEl = $fieldContainer.find('#easepick')[0];
        var picker = easepickEl && findPickerForElement(easepickEl);
        var container = picker && picker.ui && picker.ui.container;
        if (!container) {
            return;
        }
        var target = container.querySelector('.day.start, .day.end, .day.selected')
            || container.querySelector('.day.today')
            || container.querySelector('.day.unit:not(.locked):not(.not-available)');
        if (target) {
            e.preventDefault();
            target.focus();
        }
    }
});

const $inputs = cache.$inputDeparture.add(cache.$inputDestination);

$inputs.on('invalid', function () {
    $(this).closest('.form-group').addClass('pb-3');
    $('#home-extended-search-form .content-cta').addClass('pb-md-3');
});

$inputs.each(function () {
    const $input = $(this);

    let hadInvalidClass = $input.hasClass('is-invalid');

    $input.on('input change', function () {
        const $this = $(this);
        const hasInvalidClass = $this.hasClass('is-invalid');

        if (hadInvalidClass && !hasInvalidClass) {
            const inputTypeClass = $this.hasClass('departure') ? 'departure' : 'destination';

            $inputs.filter('.' + inputTypeClass).each(function () {
                $(this).closest('.form-group').removeClass('pb-3');
            });

            const anyStillInvalid = $inputs.filter('.is-invalid').length > 0;
            if (!anyStillInvalid) {
                $('#home-extended-search-form .content-cta').removeClass('pb-md-3');
            }
        }

        hadInvalidClass = hasInvalidClass;
    });
});

$(document).on('input', '.search-field.departure, .search-field.destination', function () {
    const $this = $(this);
    const value = $this.val();

    const isDeparture = $this.hasClass('departure');
    const selector = isDeparture ? '.search-field.departure' : '.search-field.destination';

    $(selector).not($this).val(value);
});

cache.$body.on('homeSearch:isInvalidDeparture', () => {
    setTimeout(() => {
        $('#home-extended-search-form .content-cta button[type="submit"]').prop('disabled', false);

        const departureField = cache.$inputDeparture;

        departureField.val('');
        departureField.trigger('invalid');
        departureField.addClass('is-invalid');
        departureField.siblings('.invalid-feedback').text(departureField.data('missing-error'));

        $.spinner().stop();
    }, 10);
});

cache.$body.on('homeSearch:isInvalidDestination', () => {
    setTimeout(() => {
        $('#home-extended-search-form .content-cta button[type="submit"]').prop('disabled', false);

        const destinationField = cache.$inputDestination;

        destinationField.val('');
        destinationField.trigger('invalid');
        destinationField.addClass('is-invalid');
        destinationField.siblings('.invalid-feedback').text(destinationField.data('wrong-error'));

        $.spinner().stop();
    }, 10);
});

function destinationCheck(formElement, url = '') {
    let isDestinationError = false;
    const element = $(formElement);
    const destinationField = element.find('input.search-field.destination');
    destinationField.siblings('.invalid-feedback').text('');

    if (destinationField.length) {
        const value = destinationField.val();

        if (value) {
            let type = destinationField.data('type');
            switch (type) {
                case 'city':
                    url += '&citta=' + value;
                    break;
                case 'nation':
                    url += '&nazioni=' + value;
                    break;
                case 'geoarea':
                    url += '&aree=' + value;
                    break;
                case 'tour':
                    url += '&nome_viaggio=' + value;
                    break;
                default:
                    isDestinationError = true;
                    break;
            }
        }
    }

    if (isDestinationError) {
        cache.$body.trigger('homeSearch:isInvalidDestination');
    }

    return {
        url: url,
        isDestinationError: isDestinationError
    };
}

function handleExtendedSearchSubmit(formElement) {
    const element = $(formElement);
    const searchForm = element[0].closest('.suggestions-search-form')[0];
    const geocode = element.find('.search-field.departure').attr('data-geocode');

    const departureField = $('input.search-field.departure');
    departureField.siblings('.invalid-feedback').text('');

    let isDepartureError = false;
    if (!geocode) {
        cache.$body.trigger('homeSearch:isInvalidDeparture');
        isDepartureError = true;
    }

    let url = searchForm.form.action + '?id_geoname=' + geocode;

    const destinationResult = destinationCheck(element, url);
    const isDestinationError = destinationResult.isDestinationError;
    url = destinationResult.url;

    if (isDepartureError || isDestinationError) {
        return;
    }

    const datepickerEl = element.find('input.search-field.datepicker');
    if (datepickerEl.length) {
        let value = datepickerEl.val();

        if (value) {
            const startDate = dateHelpers.formatTimestampToDate(datepickerEl.siblings('.js-datepicker-start-date').val());
            const endDate = dateHelpers.formatTimestampToDate(datepickerEl.siblings('.js-datepicker-end-date').val());

            url += '&data_da=' + startDate + '&data_a=' + endDate;
        }
    }

    window.location.href = url;
}

cache.$form.on('submit', function (e) {
    e.preventDefault();
    handleExtendedSearchSubmit(this);
});

cache.$form.find('button[type="submit"]').on('click', function (e) {
    const form = this.form;
    e.preventDefault();

    if (form.checkValidity()) {
        handleExtendedSearchSubmit(form);
    } else {
        // check only destination field, departure field is invalid
        destinationCheck(this.form);
        cache.$body.trigger('homeSearch:isInvalidDeparture');
    }
});

cache.$body.on('click', '#home-extended-search-form .search-field', (e) => {
    e.preventDefault();

    if (BreakpointHelper.isDownTo('lg')) {
        const clickedId = $(e.currentTarget).attr('id');

        if (clickedId) {
            const modalId = `#modal-${clickedId}`;
            const $modal = $(modalId);

            // move the modal to the last element of the body if it isn't already
            if (!$modal.parent().is('body')) {
                $modal.appendTo('body');
            }

            $modal.modal('show');
        }
    }
});

cache.$body.on('mousedown', '.modal-search-field .item.suggestion-result', (e) => {
    e.preventDefault();

    const $clickedItem = $(e.currentTarget);

    const nameValue = $clickedItem.find('.name').text().trim();

    const $searchField = $clickedItem.closest('.field-container').find('input.search-field');
    const $link = $clickedItem.find('.item-link');

    $searchField.val(nameValue);
    $searchField.focus();

    const geocode = $link.data('geocode');
    if (geocode) {
        $searchField.attr('data-geocode', geocode);

        if ($searchField.hasClass('is-invalid')) {
            $searchField.removeClass('is-invalid');
        }
    }

    if ($clickedItem.find('[id^="product-"]').length) {
        $searchField.removeAttr('data-type');
        $searchField.attr('data-type', 'tour');
    }

    const $categoryElement = $clickedItem.find('[id^="category-"]');
    if ($categoryElement.length) {
        const dataType = $categoryElement.data('type');

        if (dataType) {
            $searchField.removeAttr('data-type');
            $searchField.attr('data-type', dataType);
        }
    }

    const modalId = $clickedItem.closest('.modal').attr('id');

    if (modalId) {
        const relatedId = modalId.replace(/^modal-/, '');

        const $relatedField = $(`#${relatedId}`);

        if ($relatedField.length) {
            $relatedField.val(nameValue);

            if (geocode) {
                $relatedField.attr('data-geocode', geocode);

                if ($relatedField.hasClass('is-invalid')) {
                    $relatedField.removeClass('is-invalid');
                }
            }

            if ($clickedItem.find('[id^="product-"]').length) {
                $relatedField.removeAttr('data-type');
                $relatedField.attr('data-type', 'tour');
            }

            if ($categoryElement.length) {
                const dataType = $categoryElement.data('type');

                if (dataType) {
                    $relatedField.removeAttr('data-type');
                    $relatedField.attr('data-type', dataType);
                }
            }
        }
    }
});

if (cache.$form.length) {
    $(window).on('resize', function() {
        if (BreakpointHelper.isUpTo('lg')) {
            $('.modal-search-field').modal('hide');
        }
    });
}
